import React, { useEffect, useState } from "react";
import classNames from "classnames";
import axios from "axios";
import logo from "../assets/res/logo_infinite.svg";
import GamesPage from "./GamesPage";
import AppsPage from "./AppsPage";
import BottomNav from "../components/BottomNavigationBar";
import getRandomElements from "../utils/Helpers";
import { Container, CircularProgress, Drawer, Button } from "@mui/material";
import { Helmet } from "react-helmet-async";

import SearchPage from "./SearchScreen";
import DetailsPage from "./DetailsPage";
import { GET_BASE_URL } from "../utils/Constants";

const MainPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [items, setItems] = useState([]);
  const [homeOffers, setHomeOffers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState("Games");
  const [showOverlayHeader, setShowOverlayHeader] = useState(false);

  const handleScrollTop = () => {
    const position = window.scrollY;

    if (position > 10) {
      setShowOverlayHeader(true);
    } else {
      setShowOverlayHeader(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.post(GET_BASE_URL() + "get_game.php");
      setItems(response.data.reverse());
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchHomeOffers = async () => {
    try {
      const response = await axios.get(GET_BASE_URL() + "offers.php", {
        params: { niche_name: "main_page" }
      });
      setHomeOffers(response.data);
    } catch (_) {
      // silently fail — section just won't render
    }
  };

  useEffect(() => {
    fetchData();
    fetchHomeOffers();

    window.addEventListener("scroll", handleScrollTop, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScrollTop);
    };
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  if (error) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center gap-4 px-8"
        style={{ background: "linear-gradient(135deg, #012a4a 0%, #013a63 25%, #01497c 50%, #468faf 100%)" }}
      >
        <img src={logo} width="56" height="56" alt="Infinite Mod" className="mb-2 opacity-80" />
        <h2 className="semiBold text-white text-xl text-center">Couldn't load games</h2>
        <p className="medium text-white/50 text-sm text-center">Check your connection and try again.</p>
        <button
          onClick={() => { setError(false); setLoading(true); fetchData(); }}
          className="mt-2 px-8 py-3 rounded-2xl bg-light-blue text-white semiBold text-base"
        >
          Try Again
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "linear-gradient(135deg, #012a4a 0%, #013a63 25%, #01497c 50%, #468faf 100%)" }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-20 w-64 h-64 rounded-full opacity-20 animate-pulse"
            style={{ background: "radial-gradient(circle, #468faf, transparent)" }} />
          <div className="absolute bottom-20 right-20 w-96 h-96 rounded-full opacity-20 animate-pulse delay-700"
            style={{ background: "radial-gradient(circle, #01497c, transparent)" }} />
        </div>
        <div className="flex flex-col items-center gap-4 z-10">
          <img src={logo} width="64" height="64" alt="Infinite Mod" className="mb-2" />
          <h1 className="pressStart text-2xl tracking-wider text-white mb-4">MOD</h1>
          <div className="flex gap-2">
            <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
            <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
            <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
          </div>
        </div>
      </div>
    );
  }



  return (
    <>
      <Helmet>
        <title>Infinite Mod</title>
        <meta
          name="description"
          content="android and ios games and mods apk and ipa file"
        />
      </Helmet>
      <div className="flex flex-col align-middle bg-semi-blue">
        <div className={page === "Games" ? "block page-enter" : "hidden"}>
          <GamesPage
            handleItemClick={handleItemClick}
            handleSearchEvent={setPage}
            showOverlayHeader={showOverlayHeader}
            numbers={items}
            homeOffers={homeOffers}
          />
        </div>
        <div className={page === "Apps" ? "block page-enter" : "hidden"}>
          <AppsPage
            handleItemClick={handleItemClick}
            handleSearchEvent={setPage}
            showOverlayHeader={showOverlayHeader}
            gamesData={items}
            homeOffers={homeOffers}
          />
        </div>
        <div className={page === "Search" ? "block page-enter" : "hidden"}>
          <SearchPage
            handleItemClick={handleItemClick}
            handleBackAction={setPage}
            showOverlayHeader={showOverlayHeader}
            numbers={items}
            isActive={page === "Search"}
          />
        </div>

        <Drawer
          anchor="bottom"
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxWidth: "512px",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "16px 16px 0 0",
              background: "#013a63",
            }
          }}
        >
          <DetailsPage
            fromPage={page}
            selectedGame={selectedItem}
            handleClose={handleClose}
            numbers={getRandomElements(items, 5)}
          />
        </Drawer>

        <BottomNav page={page} setPage={setPage} />
      </div>
    </>
  );
};

export default MainPage;
